export const GET_STATUS_LEAD = "GET_STATUS_LEAD"
export const GET_STATUS_LEAD_SUCCESS = "GET_STATUS_LEAD_SUCCESS"
export const GET_STATUS_LEAD_FAIL = "GET_STATUS_LEAD_FAIL"